import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import React, { useContext, useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
import { Row } from 'react-table';
import ActionModal from '@components/Modal/ActionModal';
import { useNavigate } from 'react-router-dom';
import { legacyRoutes } from '../constants';
import { LegacyItemContext } from '../context/LegacyItemContext';
import { LegacyActions } from '../redux/actions';
import HoverDropdown from '@components/CustomDropdown/HoverDropdown';
import DrawerSidebar from '@components/Drawer/DrawerSidebar';
import LegacyPage from '../../LegacyCodeHistory/components/LegacyPage';
import { LegacyCodeHistoryContext } from '../../LegacyCodeHistory/context/LegacyCodeHistoryContext';

interface IProps {
  row: Row;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const LegacyTableActions: React.FC<IProps> = ({ row }) => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const { getItems } = useContext(LegacyItemContext);
  const history = useNavigate();
  const { setQueries, advancedSearch, setItems } = useContext(LegacyCodeHistoryContext);
  const deleteItem = () => {
    LegacyActions.deleteItem(row.values['productItemID']).then((res) => {
      getItems();
      setIsModalOpen(false);
    });
  };

  return (
    <div className='actions-right' style={{ display: 'flex' }}>
      <Tooltip
        id='expander'
        onClick={() => {
          history(legacyRoutes.getEditLink(row.values['productItemID']));
        }}
        title='Edit '
        placement='top'
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id='expander'
          aria-label='Edit'
          className={classes.tableActionButton}
        >
          <Edit
            className={classes.tableActionButtonIcon + ' ' + classes.edit}
          />
        </IconButton>
      </Tooltip>
      <Tooltip
        title='Delete '
        placement='top'
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id='expander'
          aria-label='Delete'
          className={classes.tableActionButton}
          onClick={() => setIsModalOpen(true)}
        >
          <Delete
            className={classes.tableActionButtonIcon + ' ' + classes.edit}
          />
        </IconButton>
      </Tooltip>
      <HoverDropdown
        menus={[
          {
            name: 'Code History',
            action: () => {
              setItems([]) // reset codeHistory
              setQueries([{ column: 'productItemID', value: row.values['productItemID'] }]);
              advancedSearch([{ column: 'productItemID', value: row.values['productItemID'] }]);
              setHistoryModalOpen(true);
            },
          },
        ]}
      />
      <DrawerSidebar
        isModalOpen={historyModalOpen}
        toggleModal={setHistoryModalOpen}
        title={`Code History ${row.values['productItemOEM_SN']}`}
        styles={{ minWidth: '800px', maxWidth: '940px' }}
      >
        {historyModalOpen ? <LegacyPage isLoading={true} /> : null}
      </DrawerSidebar>
      <ActionModal
        isModalOpen={isModalOpen}
        toggleModal={setIsModalOpen}
        handleOnClickOkey={deleteItem}
        handleOnClickCancel={() => setIsModalOpen(false)}
        okText='Delete'
      >
        <div>Are you sure you want to delete?</div>
      </ActionModal>
    </div>
  );
};

export default LegacyTableActions;
